import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTaskV2EditComponent } from './fi-task-v2-edit.component';
import { FormsModule } from '@angular/forms';
import { FiTaskV2EditNameComponent } from './fi-task-v2-edit-name/fi-task-v2-edit-name.component';
import { FiTaskV2EditAssignComponent } from './fi-task-v2-edit-assign/fi-task-v2-edit-assign.component';
import { FiTaskV2EditPriorityComponent } from './fi-task-v2-edit-priority/fi-task-v2-edit-priority.component';
import { FiTaskV2EditDeadlineComponent } from './fi-task-v2-edit-deadline/fi-task-v2-edit-deadline.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatInput, MatInputModule, MatLabel } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FiEditorPageHeaderModule } from '@fi-shared/fi-editor-page-header/fi-editor-page-header.module';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { TaskEditTaskAssigneeModule } from '@fi-shared/fi-task-shared/task-edit-task-assignee/task-edit-task-assignee.module';
import { FiTaskV2EditPrioritySimpleComponent } from '@fi-app/task-v2/fi-task-v2-edit/fi-task-v2-edit-priority-simple/fi-task-v2-edit-priority-simple.component';
import { FiNameDescriptionInputModule } from '@fi-app/shared/name-description-input/name-description-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        MatInputModule,
        MatFormFieldModule,
        MatInput,
        MatLabel,
        FiContenteditableModule,
        MatDividerModule,
        MatIconModule,
        MatOptionModule,
        MatSelectModule,
        FiErrorMessageModule,
        FiProfileIconModule,
        MatRadioButton,
        MatRadioGroup,
        SelectSearchModule,
        FiDatePickerModule,
        FiValidatingFormModule,
        MatButtonModule,
        MatCardModule,
        FiEditorPageHeaderModule,
        FiSimpleContenteditableModule,
        TaskEditTaskAssigneeModule,
        FiNameDescriptionInputModule,
    ],
    declarations: [
        FiTaskV2EditComponent,
        FiTaskV2EditNameComponent,
        FiTaskV2EditAssignComponent,
        FiTaskV2EditPriorityComponent,
        FiTaskV2EditDeadlineComponent,
        FiTaskV2EditPrioritySimpleComponent,
    ],
    exports: [FiTaskV2EditPrioritySimpleComponent],
})
export class FiTaskV2EditModule {}
